export const liveChatStyles = `
  iframe#usercom-launcher-dot-frame[name] {
    display: none!important;
  }
  
@media only screen and (max-width: 767px) {
  iframe#usercom-launcher-dot-frame[name] {
    display: none!important;
  }

  .livecall-callback-v1-widget.livecall-placement-bottom-left .livecall-callback-v1-overlay-container .livecall-callback-v1-overlay {
    bottom: 9px!important;
    left: 15px!important;
  }

  .livecall-callback-v1-widget .livecall-callback-v1-avatar-icon {
    width: 40px!important;
    height: 40px!important;
    zoom: 0.5;
    -moz-transform:scale(0.5);
    -moz-transform-origin: 0 0;
    margin: 15px!important;
  }

  .livecall-callback-v1-widget.livecall-placement-bottom-left .livecall-callback-v1-avatar {
    width: 35px!important;
    height: 35px!important;
  }
}
`;
